import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import About from './About';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Service from './Service';
import Contact from './Contact';
import Client from './Client';
import Team from './Team';
import  Navbar  from '../Component/Navbar';
const homeStyles = `
  html, body {
    width: 100vw;
    overflow-x: hidden !important;
  }
  body {
    font-family: "Poppins", sans-serif;
    background: linear-gradient(135deg, #f8fafc, #eef2f3);
    scroll-behavior: smooth;
    color: #333;
  }
  main, .container, .row, .offcanvas, .hero, section {
    max-width: 100vw;
  }

  /* HERO SECTION */
  .hero {
    background: linear-gradient(rgba(0,0,0,0.45),rgba(0,0,0,0.65)), url("img/service3.png") center/cover no-repeat;
    color: #fff;
    min-height: 85vh;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  .hero h1 {
    font-weight: 700;
    font-size: 2.4rem;
    letter-spacing: 0.5px;
  }
  .hero p {
    font-size: 1.15rem;
    margin-top: 10px;
    opacity: 0.9;
  }

  /* SERVICE CARDS */
  .service-card img {
    width: 100%;
    height: 220px;
    object-fit: cover;
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
  }

  .service-card {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  .service-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 20px rgba(0,0,0,0.15);
  }

  /* CALL BUTTON */
  .call-now {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 999;
  }
  .call-now a {
    background: #28a745;
    color: #fff;
    padding: 14px 18px;
    border-radius: 50%;
    font-size: 1.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    box-shadow: 0 6px 16px rgba(0,0,0,0.3);
    animation: pulse 2s infinite;
    transition: background 0.3s ease;
  }
  .call-now a:hover {
    background: #218838;
  }

  @keyframes pulse {
    0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4); }
    70% { transform: scale(1.1); box-shadow: 0 0 0 15px rgba(40, 167, 69, 0); }
    100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(40, 167, 69, 0); }
  }

  @media (max-width: 768px) {
    .hero h1 { font-size: 1.5rem; }
    .service-card img { height: 160px; }
    .call-now { display: block; }
    #about ul, #about li { font-size: 1.05rem; }
  }
`;

const Home = () => {
  useEffect(() => {
    AOS.init({ duration: 900, once: true });
  }, []);

  return (
    <>
      <style>{homeStyles}</style>

      <main>
        <Navbar />
        {/* HERO */}
        <section className='hero' id='home' data-aos='fade-in'>
          <div className='container'>
            <div className='row justify-content-center'>
              <div
                className='col-lg-8 col-md-10'
                data-aos='fade-up'
                data-aos-delay='200'
              >
                <h1>Professional Bird Netting Services in Pune</h1>
                <p>
                  Keep your balconies, terraces, and industrial spaces clean
                  &amp; bird-free. Expert team, premium quality nets.
                </p>
                <div
                  className='d-flex flex-wrap justify-content-center gap-3 mt-4 contact-hero'
                  data-aos='fade-up'
                  data-aos-delay='400'
                >
                  <a
                    href='https://mail.google.com/mail/?view=cm&fs=1&to=kamblevishvapratap@gmail.com&su=Need%20Birdnetting%20Solution%20Pune&body=I%20want%20connect%20for%20birdnetting%20service'
                    className='btn btn-outline-light'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <i className='bi bi-envelope-fill me-2'></i>
                    Email Us
                  </a>
                  <a
                    href='https://wa.link/nfcezm'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='btn btn-success'
                  >
                    <i className='bi bi-whatsapp me-2'></i>
                    WhatsApp
                  </a>
                  <a
                    href='tel:+919579858376'
                    className='btn btn-primary d-md-none'
                  >
                    <i className='bi bi-telephone-fill me-2'></i>
                    Call Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Service />
        <About />
        <Client />
        <Contact />
        <Team />
      </main>

      {/* Floating Call Button (mobile) */}
      <div
        className='call-now d-md-none'
        style={{ bottom: '40px', right: '30px' }}
      >
        <a href='tel:+919579858376' aria-label='Call Now'>
          <i className='bi bi-telephone-fill'></i>
        </a>
      </div>
    </>
  );
};

export default Home;
